module.exports = __webpack_public_path__ + "img/IG_ecuador.247eb831.jpg";